import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';

export default function ReduxContainer({ store, children }) {
  return (
    <Provider store={store}>
      {children}
    </Provider>
  );
}

/**
 * Declare the ReduxContainer component PropTypes for better validation.
 * @type {Object}
 * @property {Object} store Object containing the store instance.
 */
ReduxContainer.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  store: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/ReduxContainer.js